import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = { class: "flex-row flex-align-center bd-highlight mb-3" }
const _hoisted_3 = {
  class: "align-self-center",
  style: {"height":"30px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<option value=\"1000\">全部</option><option value=\"0\">已签约</option><option value=\"1\">已入住</option><option value=\"2\">产康客户</option><option value=\"3\">月子客户</option>", 5)
const _hoisted_10 = [
  _hoisted_5
]
const _hoisted_11 = {
  class: "input-group align-self-center ms-auto p-2 bd-highlight",
  style: {"width":"200px"}
}
const _hoisted_12 = { class: "table table-bordered table-striped table-sm member-list" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "序号"),
    /*#__PURE__*/_createElementVNode("th", null, "姓名"),
    /*#__PURE__*/_createElementVNode("th", null, "客户编号"),
    /*#__PURE__*/_createElementVNode("th", null, "手机号"),
    /*#__PURE__*/_createElementVNode("th", null, "微信号"),
    /*#__PURE__*/_createElementVNode("th", null, "咨询日期"),
    /*#__PURE__*/_createElementVNode("th", null, "顾问"),
    /*#__PURE__*/_createElementVNode("th", null, "授权码"),
    /*#__PURE__*/_createElementVNode("th", null, "操作")
  ])
], -1)
const _hoisted_14 = { id: "member-list" }
const _hoisted_15 = { class: "flex-row flex-align-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_AddCustomerDialog = _resolveComponent("AddCustomerDialog")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!
  const _component_ShowDetailDialog = _resolveComponent("ShowDetailDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary ml-5",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.exportData && $setup.exportData(...args)))
          }, "导出")
        ]),
        _hoisted_4,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.active) = $event)),
          class: "customer-select"
        }, _hoisted_10, 512), [
          [_vModelSelect, _ctx.active]
        ]),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "customer-keywords",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.keywords) = $event)),
            placeholder: "搜索"
          }, null, 512), [
            [_vModelText, _ctx.keywords]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.loadCustomerList(1)))
          }, "搜索")
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("tbody", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.customers, (value, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", null, _toDisplayString(50 * ($setup.nowPage - 1) + idx + 1), 1),
                _createElementVNode("td", null, _toDisplayString(value.name), 1),
                _createElementVNode("td", null, _toDisplayString(value.id), 1),
                _createElementVNode("td", null, _toDisplayString(value.mobile), 1),
                _createElementVNode("td", null, _toDisplayString(value.wechat), 1),
                _createElementVNode("td", null, _toDisplayString(value.addDate), 1),
                _createElementVNode("td", null, _toDisplayString(value.guwenName), 1),
                _createElementVNode("td", null, _toDisplayString(value.authCode), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("img", {
                      class: "button-icon",
                      src: "/assets/ic_edit.png",
                      onClick: ($event: any) => ($setup.openEditCustomerDialog(value.id))
                    }, null, 8, _hoisted_16),
                    _createElementVNode("img", {
                      class: "button-icon img-margin",
                      src: "/assets/ic_trash.png",
                      onClick: ($event: any) => ($setup.deleteCustomer(value.id, value.name))
                    }, null, 8, _hoisted_17),
                    _createElementVNode("img", {
                      class: "button-icon img-margin",
                      src: "/assets/ic_view.svg",
                      onClick: ($event: any) => ($setup.showDetail(value))
                    }, null, 8, _hoisted_18)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_Pagination, {
          page: $setup.nowPage,
          max: $setup.totalPage/50,
          onLoadPage: $setup.loadCustomerList
        }, null, 8, ["page", "max", "onLoadPage"])
      ])
    ]),
    _createVNode(_component_AddCustomerDialog, {
      show: _ctx.showAddDialog,
      customer: _ctx.editing,
      onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showAddDialog = false)),
      onConfirm: $setup.editCustomer
    }, null, 8, ["show", "customer", "onConfirm"]),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"]),
    (_ctx.showDetailDialog)
      ? (_openBlock(), _createBlock(_component_ShowDetailDialog, {
          key: 0,
          onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDetailDialog=false)),
          json: _ctx.detail
        }, null, 8, ["json"]))
      : _createCommentVNode("", true)
  ], 64))
}